import SectionContainer from '@/app/components/SectionContainer';
import { useCarousel, useVisibilityObserver } from '@/app/modules/HomePageV2/hooks';
import { Testimonial } from '@/app/modules/HomePageV2/types';
import cx from 'classnames';

import styles from './Testimonials.module.scss';

export interface TestimonialsProps {
  testimonials: Testimonial[];
  darkMode?: boolean;
}
const longTextThreshold = 100;

// TODO: Refactor this into a Carousel component when we need more than one carousel in the app.
export const Testimonials = ({ testimonials, darkMode = false }: TestimonialsProps) => {
  const { elementRef, isVisible } = useVisibilityObserver({ threshold: 0.1 });

  const { currentIndex, currentItem, isTransitioning, animationKey, handleIndicatorClick } =
    useCarousel<Testimonial>({ carouselData: testimonials, isVisible, autoAdvanceInterval: 7000 });

  const isLongText = currentItem.text.length > longTextThreshold;

  return (
    <SectionContainer
      ref={elementRef}
      className={cx(styles.testimonialsContainer, darkMode && styles.darkMode)}
    >
      <div
        key={currentIndex}
        className={cx(styles.testimonialContent, isTransitioning && styles.slideOut)}
      >
        <div className={styles.iconContainer}>{currentItem.svgIcon}</div>
        <p className={cx(styles.testimonialsText, isLongText && styles.longText)}>
          {currentItem.text}
        </p>
        <div className={styles.testimonialAuthorContainer}>
          <p className={styles.testimonialAuthor}>{currentItem.author}</p>
        </div>
      </div>

      <div className={styles.indicators}>
        {testimonials.map((_, index) => (
          <button
            key={`${index}-${animationKey}`} // Force re-render to restart animation
            className={cx(
              styles.indicator,
              index === currentIndex && styles.active,
              index < currentIndex && styles.completed,
            )}
            onClick={() => handleIndicatorClick(index)}
            aria-label={`View testimonial ${index + 1}`}
          />
        ))}
      </div>
    </SectionContainer>
  );
};
